import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ErrorPage from './pages/ErrorPage';
import Google from './pages/Google';
import Outlook from './pages/Outlook';
import SuccessPage from './pages/SuccessPage';

const OAUTH_CLIENT_ID =
	'569133653378-5ucq8uq7ns5t9uquai3udefdf3dfvhil.apps.googleusercontent.com';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<Routes>
				<Route path="/">
					<Route index element={<Navigate to="/google" />} />
					<Route
						path="google"
						element={
							<GoogleOAuthProvider clientId={OAUTH_CLIENT_ID}>
								<Google />
							</GoogleOAuthProvider>
						}
					/>
					<Route path="outlook" element={<Outlook />} />
					<Route path="error" element={<ErrorPage />} />
					<Route path="success" element={<SuccessPage />} />
				</Route>
			</Routes>
		</BrowserRouter>
	</React.StrictMode>,
);
